import firebase, {db, auth, fc, st} from './connection'
import store from '../store.js'

export default {
    getBestUniversities() {
        let ref = db.collection('bestUniversities').orderBy('position', 'asc');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getBestUniversity(id) {
        let ref = db.collection('bestUniversities').doc(id);
    
        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc};
                })
                .catch(error => {
                    return error;
                });
    },

    addBestUniversity(payload) {
        let ref = db.collection('bestUniversities')
    
        return ref.add(payload)
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

    // - - -

    getBestJobs() {
        let ref = db.collection('bestJobs');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getBestJob(id) {
        let ref = db.collection('bestJobs').doc(id);
    
        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc};
                })
                .catch(error => {
                    return error;
                });
    },

    addBestJob(payload) {
        let ref = db.collection('bestJobs')
    
        return ref.add(payload)
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

    setTop3Univ(name, top3Univ) {
        let ref = db.collection('bestJobs').where('name', '==', name);

        return ref.get()
                .then(query => {
                    let rof = db.collection('bestJobs').doc(query.docs[0].id);

                    return rof.update({top3Univ: top3Univ})
                        .then( () => {
                            return true;
                        })
                        .catch(error => {
                            return error;
                        });
                })
                .catch(error => {
                    return error;
                });
    
        
    },

    // ----

    getPOFs() {
        let ref = db.collection('professionsOfFuture').orderBy('position', 'asc');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getPOF(id) {
        let ref = db.collection('professionsOfFuture').doc(id);
    
        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc};
                })
                .catch(error => {
                    return error;
                });
    }
    
}